var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{class:_vm.$style.wrapper},[_c('Mobile',{class:_vm.$style.mobile,attrs:{"links":_vm.links}}),_c('Desktop',{class:_vm.$style.desktop,attrs:{"links":_vm.links}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }